
import "../../styles/results/list.scss";
import * as noUiSlider from "nouislider";
import axios from "axios";
import { parse } from "qs";
import "./mobile-slideout-options";
import dayjs from "dayjs";
import "dayjs/locale/af";
import "dayjs/locale/en";
import "../integration/leaflet/leaflet-wrapper";
import "../integration/maplibre/maplibre-wrapper";
import MoveTo from "moveto";
import { isEmpty } from "validate.js";
const bsn = require('bootstrap.native');
import 'formdata-polyfill';

const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
/**
 *
 * Variables
 */

let cancelToken;

const priceSlider = document.getElementById("js-filter-price-slider");
const inputMin = document.getElementById("js-filter-price-input-min");
const inputMax = document.getElementById("js-filter-price-input-max");

let form = document.getElementById("form-sidebar-filters");
let filterData = serializeForm(form);

const {
    page_arguments,
    maplibreMap,
    language_switch,
    is_mobile_device,
    is_app,
} = window.tg;

const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
);
const mobile_safety =
    is_mobile_device === true || vw < 440 || is_app ? true : false; // Fallback safety in case mobile device wrongly detected DEV-6156, DEV-6354 added is_app for additional fallback
const tabMap = document.getElementById("js-map-tab-canvas");
// Initialize map
const latitude = tabMap.dataset.latitude;
const longitude = tabMap.dataset.longitude;

const latMax = tabMap.dataset.latmax;
const latMin = tabMap.dataset.latmin;

const longMax = tabMap.dataset.longmax;
const longMin = tabMap.dataset.longmin;

window.resetMapRequiredFilters = function () {
    inputMax.value = inputMax.getAttribute('data-default')
    inputMin.value = inputMin.getAttribute('data-default')
    inputMax.setAttribute("disabled", "");
    inputMin.setAttribute("disabled", "");
    priceSlider.noUiSlider.set([inputMin.value, inputMax.value])
}

let serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + obj[p]);
        }
    return str.join("&");
};

function serializeForm(form) {
    const obj = {};

    if (inputMin.value != inputMin.getAttribute("data-default")) {
        inputMin.removeAttribute("disabled", "");
    }

    if (inputMax.value != inputMax.getAttribute("data-default")) {
        inputMax.removeAttribute("disabled", "");
    }

    const formData = new FormData(form);

    for (const key of formData.keys()) {
        obj[key] = formData.getAll(key);
    }

    return obj;
}

let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent("MouseEvent");
    evt.initMouseEvent(
        "click",
        true /* bubble */,
        true /* cancelable */,
        window,
        null,
        0,
        0,
        0,
        0 /* coordinates */,
        false,
        false,
        false,
        false /* modifier keys */,
        0 /*left*/,
        null
    );

    let canceled = !elem.dispatchEvent(evt);
};

// Simple onChange dispatch event to trigger waterfall when input value changes via javascript
let dispatchEventChange = function (elem) {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    elem.dispatchEvent(evt);
};

/**
 *
 * Actions
 */
dayjs.locale("af");
if (language_switch === "en") {
    dayjs.locale("en");
}
form.addEventListener("change", onChangeHandler.bind(this));

if (priceSlider) {
    noUiSlider.create(priceSlider, {
        connect: true,
        step: 10,
        margin: 100,
        behaviour: "drag-tap",
        start: [
            parseInt(priceSlider.dataset.fromValue),
            parseInt(priceSlider.dataset.toValue),
        ],
        range: {
            min: parseInt(priceSlider.dataset.min),
            max: parseInt(priceSlider.dataset.max),
        },
        tooltips: [
            {
                from: Number,
                to: function (value) {
                    const selection = parseInt(value);
                    return `R${selection}`;
                },
            },
            {
                from: Number,
                to: function (value) {
                    const selection = parseInt(value);
                    if (selection == parseInt(priceSlider.dataset.max)) {
                        return `R${selection}+`;
                    }
                    return `R${selection}`;
                },
            },
        ],
    });

    priceSlider.noUiSlider.on("change", function (values, handle) {
        // Handle 0 is minimum, Handle 1 is maximum
        let value = parseInt(values[handle]);

        if (handle == 0) {
            inputMin.value = value;
            if (value === parseInt(priceSlider.dataset.min)) {
                inputMin.setAttribute("disabled", "");
            } else {
                inputMin.removeAttribute("disabled");
            }

            inputMin.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }

        if (handle == 1) {
            inputMax.value = value;

            if (value === parseInt(priceSlider.dataset.max)) {
                inputMax.setAttribute("disabled", "");
            } else {
                inputMax.removeAttribute("disabled");
            }

            inputMax.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }
    });
}


/**
 *
 * Functions
 */

function onChangeHandler(event) {
    const dateRequiredFilters = [
        "price-high",
        "price-low",
        "from_price",
        "to_price",
        "reviews",
    ];

    const isPricePerNightFilterActive = inputMin.value != inputMin.getAttribute("data-default") || inputMax.value != inputMax.getAttribute("data-default");
    const noDatesSelected = Alpine.store('search').start.length == 0 && Alpine.store('search').end.length == 0;

    const isRecommendedSortWithPricePerNight = event.target.name === 'sort' && event.target.value === 'recommended' && isPricePerNightFilterActive && noDatesSelected;

    if (isRecommendedSortWithPricePerNight) {
        inputMax.value = inputMax.getAttribute('data-default')
        inputMin.value = inputMin.getAttribute('data-default')
        inputMax.setAttribute("disabled", "");
        inputMin.setAttribute("disabled", "");
        priceSlider.noUiSlider.set([inputMin.value, inputMax.value])

        toggleMobileTraySort(event)
    }

    if (
        Alpine.store('search').start.length == 0 &&
        Alpine.store('search').end.length == 0 &&
        (dateRequiredFilters.indexOf(event.target.value) !== -1 ||
            dateRequiredFilters.indexOf(event.target.name) !== -1)
    ) {
        if (window.innerWidth < 1028) {

        }
        Alpine.store('search').datesRequired = true

        Alpine.nextTick(() => {
            Alpine.store('general').openSection = 'SEARCH'
            setTimeout(() => {
                Alpine.store('search').houseKeeping('start');
                collapseFilterOptions();
            },250)
        })
    } else {
        showPlaceHolder(true);
        maplibreMap.addMiniMarkers('on_change');
    }
}


function fetchMarkers(type = "search", event = "") {

    if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    filterData = serializeForm(form);

    if (type === "clear-all") {
        resetFilters();
        filterData = {
            clear: 1,
        };
        form.reset();
    } else if (type === "clear-filters") {
        resetFilters();
    } else if (Alpine.store('search').start.length > 0 && Alpine.store('search').end.length > 0) {
        filterData = {
            ...filterData,
            start: Alpine.store('search').start,
            end: Alpine.store('search').end,
            room: Alpine.store('search').allocation.room.value,
            pax: Alpine.store('search').allocation.adult.value,
            adult: Alpine.store('search').allocation.adult.value,
            child: Alpine.store('search').allocation.child.value,
            child_ages: Alpine.store('search').allocation.child_ages.value,
        };
    }
    filterData = {
        ...filterData,
        latcoord: maplibreMap._map.getCenter().lat,
        lngcoord: maplibreMap._map.getCenter().lng,
        radius: maplibreMap.getRadius(),
        zoom: maplibreMap._map.getZoom(),
        event: event
    }
    cancelToken = axios.CancelToken.source();

    const queryString = serialize(filterData);
    return axios({
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "get",
        url: `/backend/results/map/${page_arguments.which}?${queryString}`,
        cancelToken: cancelToken.token,
    })
        .then(function (response) {
            if (['clear-all', 'clear-filters'].includes(type)) {
                if (type == 'clear-all') {
                    Alpine.store('search').reset()
                }

                let clearEls = document.querySelectorAll(
                    ".js-select-clear-results", ".js-select-clear-prompt"
                );

                clearEls.forEach((el) => {
                    el.classList.add("invisible");
                });
                priceSlider.noUiSlider.reset();
            } else if (Alpine.store('search').start.length > 0 && Alpine.store('search').end.length > 0) {
                // setAvailabilityButton("clear");
            }
            return response.data;
        })
        .catch(function (error) {
            if (axios.isCancel(error)) {
                console.log("Request canceled", error.message);
            }

            return false;
        });
}

function showPlaceHolder(show = true) {
    Alpine.store('search').loading = show

    let placeholderListEl = document.querySelector(".map--placeholder");

    if (show && placeholderListEl.classList.contains("d-none")) {
        placeholderListEl.classList.remove("d-none");
        placeholderListEl.classList.add("d-flex");
        return;
    }

    if (!show) {
        placeholderListEl.classList.add("d-none");
        placeholderListEl.classList.remove("d-flex");
    }
}

function setHistory() {
    let pageNumber =
        parseInt(filterData["page_number"]) > 1
            ? parseInt(filterData["page_number"])
            : 1;
    let path = getPath(pageNumber);
    delete filterData.event
    let queryString = serialize(filterData);

    // Add params since clear is not present
    if (queryString.indexOf("clear") === -1) {
        let q = queryString === "" ? "" : "?";
        path += `${q}${queryString}`;
    }

    history.replaceState(`${path}`, "Replace History", `${path}`);
    return;

}

function getPath(pageNumber) {
    const url = new URL(document.URL);

    let path = url.pathname;

    return path;
}

function collapseFilterOptions() {
    let el = document.getElementById("slideout-options");
    if (el.classList.contains('show')) {
        el.classList.remove('show');
    } else {
        el.classList.add('show');
    }
}

window.addEventListener("popstate", function (event) {
    let params = parse(event.state);

    // // Re-select based on params
    for (const element of form.elements) {
        if (["radio", "checkbox"].includes(element.type)) {
            if (
                params.hasOwnProperty(element.name) &&
                [...params[element.name]].includes(element.value)
            ) {
                element.checked = true;
            } else {
                element.checked = false;
            }
        }
    }

    // Check if from_price or to_price in params, disable input to prevent reset
    inputMin.value = params.hasOwnProperty("from_price")
        ? parseInt(params.from_price)
        : inputMin.getAttribute("data-default");
    inputMax.value = params.hasOwnProperty("to_price")
        ? parseInt(params.to_price)
        : inputMax.getAttribute("data-default");

    if (inputMin.value == inputMin.getAttribute("data-default")) {
        inputMin.setAttribute("disabled", "");
    }

    if (inputMax.value == inputMax.getAttribute("data-default")) {
        inputMax.setAttribute("disabled", "");
    }

    state = "replace";
    showPlaceHolder(true);
    maplibreMap.addMiniMarkers('popstate')
});


if (document.querySelectorAll(".js-filter-show-more").length > 0) {
    const list = document.querySelectorAll(".js-filter-show-more");

    list.forEach((element) => {
        element.addEventListener("click", function (event) {
            const el = event.target;
            const list = document.querySelectorAll(`.${el.dataset.target}`);
            const startingDisplayList = el.dataset.list;

            list.forEach((element) => {
                // For map page: check data-position (regions) or data-filter-id (filters)
                const elementId = element.dataset.position || element.dataset.filterId;

                if (
                    startingDisplayList.indexOf(elementId) == -1
                ) {
                    if (el.dataset.show == "true") {
                        element.classList.remove("d-none");
                    } else {
                        element.classList.add("d-none");
                    }
                }
            });

            const text = el.innerText;
            el.innerText = el.dataset.text;
            el.dataset.text = text;
            el.dataset.show = !(el.dataset.show == "true");

            // Update accordion height after showing/hiding items
            if (el.dataset.accordionTarget === "true") {
                const accordionPanel = el.closest('.panel');
                if (accordionPanel && accordionPanel.style.maxHeight) {
                    accordionPanel.style.maxHeight = accordionPanel.scrollHeight + "px";
                }
            }
        });
    });
}

document.addEventListener("click", function (event) {
    // Make sure clicked element is our toggle
    const el = /** @type {HTMLElement} */ (event.target);

    if (!el.classList.contains("js-clear-filters")) {
        return;
    }

    event.preventDefault();
    const moveTo = new MoveTo({
        tolerance: 0,
        duration: 50,
        easing: "easeOutQuart",
        container: window,
    });

    resetFilters();
    moveTo.move(document.getElementById("section-top"));
    showPlaceHolder(true);
    maplibreMap.addMiniMarkers('clear-filters');
});

maplibreMap.addMiniMarkers = async function (event = "") {
    showPlaceHolder(true);

    let action = 'search'

    if (this._map != null) {
        this._miniLoadedAtZoom = this._map.getZoom();
        this._miniLoadedAtLat = this._map.getCenter().lat;
        this._miniLoadedAtLng = this._map.getCenter().lng;
    }

    let response = await fetchMarkers(action, event)
    let data = response.data

    if (response !== false) {
        if (response.hasOwnProperty('additional_data')) {
            for (const [key, value] of Object.entries(response.additional_data)) {
                Alpine.store('results')[key] = value;
            }
        }
        if (data.markers !== null) {
            this.createMapMarkers(data.markers, event);
        }
    }
    showPlaceHolder(false);
    priceSlider.noUiSlider.set([inputMin.value, inputMax.value]); // Simply animate the current values, this does not trigger change event on slider
    setHistory();

}

maplibreMap.initialize([parseFloat(longitude), parseFloat(latitude)], {
    identifier: "js-map-tab-canvas",
    showCenterMarker: false,
    fitBounds: true,
    latMax: latMax,
    latMin: latMin,
    longMax: longMax,
    longMin: longMin
});

var acc = document.getElementsByClassName("sp-accordion");

var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {

        var panel = this.nextElementSibling;

        this.classList.toggle("active");

        if (panel.style.display === "block") {
            panel.style.display = "none";
        } else {
            panel.style.display = "block";
        }

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

window.fetchMapResults = function () {
    showPlaceHolder(true);
    maplibreMap.addMiniMarkers();
}

let resetFilters = function () {
    resetMapRequiredFilters()
    // Reset any other values than checked
    form.reset()

    inputMax.setAttribute("disabled", "");
    inputMin.setAttribute("disabled", "");

    // Reset checked values
    let inputEls = form.querySelectorAll('input')
    inputEls.forEach(el => {
        el.checked = false;
    })

    // Clear any filterData
    filterData = {}
}
